export const mailRegExp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
export const phoneRegExp = /^\d{10}$/

export const numberRegExp = /^(\d)+$/
export const timeRegExp = /([0-9]{2})(:)([0-9]{2})/
export const boolRegExp = /^(true|false)$/
export const passwordRegExp = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).{5,64}$/
export const notAlowedCharactersRegExp = /[^\w\d,.;:+\-*/{}\[\]\(\)@ ]/
// Min character = 6
// Max character = 64
// Min 1 lowercase character
// Min 1 uppercase character
// Min 1 number
// Min 1 special characters
